export default [
	{
		path: "/pros/profile/edit-info",
		exact: true,
		component: "EditProfile/EditProfile",
		mui: true,
	},
];
